export default __webpack_public_path__ + "static/media/mobile-banner-new.fcc50a04.svg";